import type { ValueOf } from './util/typeUtils';

export const HUBSPOT_CONTACT_RECORD_URL_PREFIX = 'https://app-eu1.hubspot.com/contacts/26478815/record/0-1/';

// fixed v5 namespace for Partner aggregate ids — never change, the duplicate guard relies on stable ids
export const PARTNER_AGGREGATE_NAMESPACE = '4fcbd5f0-bc78-4979-82fb-7a5d3f28e727';

export const PARTNER_LEVELS = {
    affiliate: 'affiliate',
    amendment_leads: 'amendment_leads',
    amendment_pos_autokredit_com: 'amendment_pos_autokredit_com',
    amendment_schufa: 'amendment_schufa',
    cooperation: 'cooperation',
    cooperation_0_percent: 'cooperation_0_percent',
    cooperation_pos: 'cooperation_pos',
    cooperation_pos_autokredit_com: 'cooperation_pos_autokredit_com',
    employee: 'employee',
    hgb_84: 'hgb_84',
    hgb_93: 'hgb_93',
    kredit_de_branch: 'kredit_de_branch',
    kredit_de_representant: 'kredit_de_representant',
    mandatory_clearing: 'mandatory_clearing',
} as const;

export type PARTNER_LEVEL = ValueOf<typeof PARTNER_LEVELS>;

export const TIPSTER_ELIGIBLE_LEVELS = [PARTNER_LEVELS.cooperation, PARTNER_LEVELS.hgb_84, PARTNER_LEVELS.hgb_93];

export const LEAD_SOURCE_PARTNER_ELIGIBLE_LEVELS = [PARTNER_LEVELS.affiliate, PARTNER_LEVELS.cooperation];

export const HGB84_LEVELS = {
    D: 'D',
    JB: 'JB',
    SB: 'SB',
    TL: 'TL',
    VD: 'VD',
} as const;

export type HGB84_LEVEL = ValueOf<typeof HGB84_LEVELS>;

export const HGB93_LEVELS_PK = {
    PK_FP: 'PK-FP',
    PK_FP_PLUS: 'PK-FP+',
    PK_P: 'PK-P',
    PK_P_PLUS: 'PK-P+',
    PK_PP: 'PK-PP',
} as const;

export type HGB93_LEVEL_PK = ValueOf<typeof HGB93_LEVELS_PK>;

export const HGB93_LEVELS_BF = {
    BF_FP: 'BF-FP',
    BF_FP_PLUS: 'BF-FP+',
    BF_P: 'BF-P',
    BF_P_PLUS: 'BF-P+',
    BF_PP: 'BF-PP',
} as const;

export type HGB93_LEVEL_BF = ValueOf<typeof HGB93_LEVELS_BF>;

export const PARTNER_LOCK_REASONS = {
    NOT_IN_API_RESPONSE: 'Partner no longer present in API response',
} as const;

export type PARTNER_LOCK_REASON = ValueOf<typeof PARTNER_LOCK_REASONS>;

export const PARTNER_UNLOCK_REASONS = {
    REAPPEARED_IN_API_RESPONSE: 'Partner reappeared in API response',
} as const;

export type PARTNER_UNLOCK_REASON = ValueOf<typeof PARTNER_UNLOCK_REASONS>;

// Derived from the `locked` flag rather than a stored field, so this is the only place that names the two states.
export const PARTNER_STATUSES = {
    active: 'active',
    locked: 'locked',
} as const;

export type PARTNER_STATUS = ValueOf<typeof PARTNER_STATUSES>;
